import '../App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import useAuth from '../hooks/useAuth';
import axios from '../apis/Axios';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

function DeleteAccount() {
    const { auth } = useAuth();
    const { setAuth } = useAuth();
    const privateAxios = useAxiosPrivate();
    
    const navigate = useNavigate();


    const deleteUser = async() => {
        try {
            var userID = auth.userID;
            const res = await privateAxios.delete('api/User/' + userID);
            setAuth({});
            navigate('/deleted-status');
        }
        catch(err) {
            console.log(err);
        }
    }

    var content = 'Delete account?';

    return (
        <>
        <div>
            <div>
                <span>
                    <label class='header h2 mt-5'>Delete Account</label>
                </span>
                <div class='delete-account-content'>
                    <div class='delete-account-content-text'>
                        { content }
                    </div>
                    <div class='delete-account-content-buttons'>
                        <button class='btn btn-dark me-2 mt-2' type='button' onClick={ deleteUser }>
                            <span class='button-delete-text'>
                                Delete Account
                            </span>
                            <span class='button-icon-delete'>
                                <i class='bi bi-trash-fill h5'></i>
                            </span>
                        </button>
                        <a href='/'>
                            <button class='btn btn-outline-dark me-2 mt-2' type='button'>
                                <span class='button-delete-text'>
                                    Return
                                </span>
                            </button>
                        </a>
                </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default DeleteAccount;